"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
owa_bundling_1.preloadScriptChunk('OptOutDialog');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "OptOutDialog" */ './lazyIndex');
});
exports.lazyShowOptOutDialog = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.showOptOutDialog; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-opt-out-view/lib/index.js
// module id = 5636
// module chunks = 62